import { forwardRef } from 'react';
import ToolTip from '../trustyle-tool-tip';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var SimpleRadio = /*#__PURE__*/forwardRef(function (props, ref) {
  return _jsxs("label", {
    sx: {
      display: 'block',
      mr: 'md',
      width: '100%',
      variant: 'elements.simple-radio.label'
    },
    children: [_jsx("input", {
      sx: {
        appearance: 'none',
        position: 'absolute',
        '&:checked + span': {
          '&::before': {
            transition: 'background-color 200ms, border-color 200ms'
          }
        },
        variant: 'elements.input.radio.base'
      },
      type: "radio",
      name: props.name,
      value: props.value,
      ref: ref,
      onClick: props.onClick,
      defaultChecked: props.defaultChecked,
      label: props.label
    }), _jsx("span", {
      sx: {
        variant: props.hasError ? 'elements.simple-radio.variants.error' : 'elements.simple-radio.span'
      },
      children: _jsxs("div", {
        sx: {
          display: 'flex',
          flexGrow: '1',
          justifyContent: 'space-between'
        },
        children: [props.label, props.toolTip ? _jsx(ToolTip, {
          content: props.toolTip.content,
          title: props.toolTip.title,
          variant: 'radio'
        }) : null]
      })
    })]
  });
});
export default SimpleRadio;
//# sourceMappingURL=index.js.map